import { Injectable } from '@angular/core';
import Client, { Stories, Story, StoryParams, StoriesParams } from 'storyblok-js-client';
import { environment } from '~env/environment';
import { PREVIEW_WINDOW_LABEL } from '../constants';
import { HttpClient } from '@angular/common/http';
import { StoryblokApiResponse } from '../models/storyblok-api-response.model';
import { STORYBLOK_STORY_API } from '../constants/storyblok-api.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoryblokService {
  constructor(private http: HttpClient) {}

  private sbClient = new Client({
    accessToken: environment.storyToken(),
  });

  isPreviewMode(): boolean {
    return window.location.search.includes(PREVIEW_WINDOW_LABEL);
  }

  getStory(slug: string, params: StoryParams = {}): Promise<Story> {
    if (this.isPreviewMode()) {
      params.version = 'draft';
    }

    return this.sbClient.getStory(slug, params);
  }

  // storyblok sdk puts params in random order
  // so when loading a page with guard, it will be called multiple times
  // this function ensures the orders is always the same and gets cached in the browser
  getStoryByHttp(slug: string): Observable<StoryblokApiResponse> {
    let version = 'published';

    if (this.isPreviewMode()) {
      version = 'draft';
    }

    return this.http
      .get<StoryblokApiResponse>(
        `${STORYBLOK_STORY_API}/${slug}?&token=${environment.storyToken()}&version=${version}`
      );
  }

  getStories(params: StoriesParams = {}): Promise<Stories> {
    if (this.isPreviewMode()) {
      params.version = 'draft';
    }
    if (params.starts_with) {
      params.starts_with = `[default]/${params.starts_with}`;
    }

    return this.sbClient.getStories(params);
  }

  checkContentReload(): void {
    if (window.storyblok) {
      window.storyblok.init({
        accessToken: environment.storyToken(),
      });
      window.storyblok.on(['change', 'published'], function () {
        location.reload();
      });
    }
  }
}
